import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { authLogin } from '@core/auth/store/auth.actions';
import { AppState } from '@core/core.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { clientPath, researchesPath } from '../../app-routing.module';

/** Passes HttpErrorResponse to application-wide error handler */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private store: Store<AppState>, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if ([401, 403].includes(err.status)) {
              this.store.dispatch(authLogin());
            } else if (err.status === 500) {
              let url = this.router.url;
              if (url.includes(clientPath)) {
                url = url.substring(0, url.lastIndexOf('/'));
              } else {
                url = researchesPath;
              }
              const newUrl = url + '/error';
              this.router.navigate([newUrl]);
            } else {
              const appErrorHandler = this.injector.get(ErrorHandler);
              appErrorHandler.handleError(err);
            }
          }
        }
      })
    );
  }
}
